/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import get from 'lodash/get';

import CommunicatorUtility from '../utility/communicator-utility';

/**
 * Komunikátor šablon pro Ki-Wi Server.
 */
class CommunicatorLayout {
  /**
   * Vytvoří instanci.
   * @param {CommunicatorLayer} communicatorLayer Komunikátor vrstev šablon.
   * @returns {CommunicatorLayout} Nová instance.
   */
  constructor(communicatorLayer) {
    this.communicatorLayer = communicatorLayer;
  }

  /**
   * Načte šablonu z JSON.
   * @param {Store} store Datový sklad ke vložení šablony.
   * @param {Object} json Část odpovědi na obsah zařízení se šablonou.
   * @returns {Layout} Šablona.
   */
  parse(store, json) {
    return store.inject('layout', {
      backgroundColor: json.bgColor,
      id: json.id,
      mediumId: CommunicatorUtility.parseReference(json.bgImage.ref, 'media', {
        nil: null
      }),
      name: json.name,
      playDuration: CommunicatorUtility.parseTime(
        get(json, 'playLength.timeLength')
      )
    });
  }

  /**
   * Načte vrstvy šablony z JSON.
   * @param {Store} store Datový sklad ke vložení vrstev.
   * @param {Object} json Část odpovědi na obsah zařízení se šablonou.
   * @returns {Array.<Layer>} Seznam vrstev.
   */
  parseLayers(store, json) {
    return json.items.map((item, index) =>
      this.communicatorLayer.parse(store, item, json.id, index)
    );
  }
}

export default CommunicatorLayout;
